import { render, staticRenderFns } from "./tableCuti.vue?vue&type=template&id=6fe7c057&scoped=true"
import script from "./tableCuti.vue?vue&type=script&lang=js"
export * from "./tableCuti.vue?vue&type=script&lang=js"
import style0 from "./tableCuti.vue?vue&type=style&index=0&id=6fe7c057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe7c057",
  null
  
)

export default component.exports